require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-our-build-partner-ironside-are-making-great-progress.json") })
        }
      }, "path---news-our-build-partner-ironside-are-making-great-progress");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-our-build-partner-ironside-are-making-great-progress!./.cache/json/news-our-build-partner-ironside-are-making-great-progress.json
// module id = 838
// module chunks = 231608221292675